import React, { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import { updateClient } from "services/custom-features";
import ClientCreate from "./ClientCreate";

// Define defaultWebhookMap as a string for reuse
const defaultWebhookMap = JSON.stringify({
  defaultUrl: {
    "url": "",
    "method": "POST"
  },
  updateFieldTask: {},
  updateWorklog: {},
  bulkUploadTask: {},
  startTravelTime: {},
  stopTravelTime: {},
  cancelTravelTime: {},
  onsiteTravelTime: {},
  releaseTravelTime: {},
  updateFacilityRequest: {},
  takeFieldTask: {},
  takefieldtaskandtravel: {},
  createFieldTask: {}
}, null, 2);

const defaultHeaders = JSON.stringify({}, null, 2);

function ClientEditPopup(props) {
  const { handler, open, setNotification, client, clientEnv, showClientListByEnv, scrollToTopOfPage} = props;

  const [errors, setErrors] = useState({});

  const updateClientOnboarding = async (event) => {
    event.preventDefault();
    let {
      clientName,
      clientEmail,
      env,
      webhookAuthType,
      webhookAuthId,
      webhookAuthSecret,
      webhookContentType,
      webhookGrantType,
      webhookScope,
      webhookTokenUrl,
      clientId,
      webhooksMap,
      headers
    } = formData;

    const newErrors = {};

    if (!clientName) {
      newErrors.clientName = "Client name is required**";
    }

    if (!clientEmail) {
      newErrors.clientEmail = "Client email is required**";
    }

    if (!env) newErrors.env = "Environment is required";

    if (webhookAuthType) {
      if (!webhookAuthId)
        newErrors.webhookAuthId = "Webhook Username is required**";
      // if (!webhookAuthSecret)
      //   newErrors.webhookAuthSecret = "Webhook Password is required**";
      if (webhookAuthType === "OAUTH2" && !webhookTokenUrl)
        newErrors.webhookTokenUrl = "Webhook Token URL is required**";
    }

    if (!webhookAuthType) {
      webhookAuthId = "";
      webhookAuthSecret = "";
      webhookContentType = "";
      webhookGrantType = "";
      webhookTokenUrl = "";
      webhookScope = "";
    }
    if (Object.keys(newErrors).length === 0) {
      const updatePayload = {
        clientName,
        clientEmail,
        env,
        webhookAuthType,
        webhookAuthId,
        webhookContentType,
        webhookGrantType,
        webhookScope,
        webhookTokenUrl,
        clientId,
        webhooksMap,
        headers,
        ...(webhookAuthSecret && { webhookAuthSecret }),
      };

      const response = await updateClient(updatePayload);

      setNotification({
        status: response.status,
        showMessage: true,
        message: response.message,
      });
      handler(false);
      showClientListByEnv(null, false);
      scrollToTopOfPage();
    
      setFormData({
        clientName: "",
        clientEmail: "",
        env: "",
        webhookAuthType: "",
        webhookAuthId: "",
        webhookAuthSecret: "",
        webhookContentType: "",
        webhookGrantType: "",
        webhookScope: "",
        webhookTokenUrl: "",
        webhooksMap: {
          defaultUrl: {
            url: "https://example.com",
            method: "POST",
          },
        },
        headers: defaultHeaders
      });
      setErrors({});
    } else {
      // Display validation errors
      setErrors(newErrors);
    }
  };

  const [formData, setFormData] = useState({
    clientName: "",
    clientEmail: "",
    env: "",
    webhookAuthType: "",
    webhookAuthId: "",
    webhookAuthSecret: "",
    webhookContentType: "",
    webhookGrantType: "",
    webhookScope: "",
    webhookTokenUrl: "",
    clientId: "",
    webhooksMap: defaultWebhookMap,
    headers: defaultHeaders
  });

  useEffect(() => {
    if (open && client) {
      setFormData({
        clientName: client.client_name,
        clientEmail: client.client_email,
        env: clientEnv,
        webhookAuthType: client.webhook_auth_type,
        webhookAuthId: client.webhook_auth_id,
        webhookAuthSecret: "",
        webhookContentType: client.webhook_content_type,
        webhookGrantType: client.webhook_grant_type,
        webhookScope: client.webhook_scope,
        webhookTokenUrl: client.webhook_token_url,
        clientId: client.client_id,
        webhooksMap: client.webhooks_map ? client.webhooks_map : defaultWebhookMap,
        headers: client.headers ? client.headers : defaultHeaders
      });
    }
  }, [open, client, clientEnv]);

  return (
    <Dialog onClose={() => handler(false)} open={open} fullWidth maxWidth='lg'>
      <DialogTitle>
        Edit Client
        <Button onClick={() => handler(false)} sx={{ float: 'right' }}>X</Button>
      </DialogTitle>
      <DialogContent dividers>
        <Container maxWidth={false} sx={{ p: 2 }}>
          <ClientCreate
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            createClientOnboarding={updateClientOnboarding}
            isEdit={true}
          />
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handler(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ClientEditPopup;
